import { memo } from "react";
import { UserLock } from "lucide-react";
import type { MCPConnectionTool } from "../../../services/agent-tools-service";
import { useTranslation } from "react-i18next";

type Props = {
  tool: MCPConnectionTool;
  onChangeAccess: (tool: MCPConnectionTool) => void;
  canManage: boolean;
};

const ToolRow = ({ tool, onChangeAccess, canManage }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-[52px] min-w-0 items-center gap-2 border-b border-border px-3 last:border-b-0">
      <span className="min-w-0 flex-1 truncate text-sm font-normal text-foreground">
        {tool.name}
      </span>
      <button
        data-mcp-tool-access={tool.id}
        type="button"
        onClick={() => onChangeAccess(tool)}
        disabled={!canManage}
        aria-label={t("mcpPage.actions.changeToolAccess", {
          name: tool.name,
        })}
        className="flex h-9 shrink-0 items-center gap-2 rounded-md px-4 text-sm font-medium text-muted-foreground outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
      >
        <UserLock className="size-4" aria-hidden="true" />
        {t("mcpPage.actions.access")}
      </button>
    </div>
  );
};

export default memo(ToolRow);
